import {Injectable} from '@angular/core';
import { Observable} from 'rxjs';
import {ProductReference } from '@spartacus/core';
import {MbFeaturedProductConnector} from '../connectors';

@Injectable({
  providedIn: 'root'
})
export class FeaturedProductService {

  constructor(
    private connector: MbFeaturedProductConnector,
  ) {
  }
  getProducts(): Observable<ProductReference[]> {
    return this.connector.get()
  }
}
